// src/pages/Home.jsx
import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import PageFooter from '../components/PageFooter';
import HomeHero from '../components/HomeHero/HomeHero';
import HomeFeatures from '../components/HomeFeatures/HomeFeatures';
import MainNoticias from '../components/MainNoticias/MainNoticias';
import HomeContacto from '../components/HomeContacto/HomeContacto';
import Recommended from '../components/ModeloDestacado/ModeloDestacado';
import Modal from '../components/Modal/Modal';
import Cotizador from '../components/Cotizador/Cotizador';
import homeFeatures from '../data/homeFeatures.json';

const Home = () => {
  const section1Ref = useRef(null);
  const contactSectionRef = useRef(null);
  const location = useLocation();
  const [cotizadorOpen, setCotizadorOpen] = useState(false);

  const openCotizador = () => setCotizadorOpen(true);
  const closeCotizador = () => setCotizadorOpen(false);

  // Meta título y descripción
  useEffect(() => {
    document.title = 'Zoomlion Latinoamérica | Home';
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content =
      'Maquinaria de alta calidad de Zoomlion Latinoamérica. Soluciones innovadoras para la construcción, minería y agricultura.';
  }, []);

  // Scroll top en '/'
  useEffect(() => {
    if (location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location.pathname]);

  // Scroll a sección de contacto
  const scrollToContact = () => {
    contactSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <div className="section" ref={section1Ref}>
        <HomeHero
          scrollToContact={scrollToContact}
          onOpenCotizador={openCotizador}
        />
      </div>

      <div className="section">
        <HomeFeatures data={homeFeatures} />
      </div>
              <Recommended />
      <div className="section" ref={contactSectionRef}>
        <HomeContacto 
          onOpenCotizador={openCotizador}
        />
      </div>

      <div className="section">
        <MainNoticias />
      </div>


      <div className="section fp-auto-height">
        <PageFooter />
      </div>

      {/* Modal Cotizador */}
      <Modal isOpen={cotizadorOpen} onClose={closeCotizador}>
        <Cotizador
          currentCountry="Perú"
          onClose={closeCotizador}
        />
      </Modal>
    </>
  );
};

export default Home;
